<template>
  <div>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16"
        ><div class="grid-content bg-purple">
          <div class="swiper">
            <el-carousel height="278px">
              <el-carousel-item
                class="swiper_item"
                v-for="item in url"
                :key="item.url"
              >
                <img class="swiper_img" :src="item.url" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div>
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6"
                ><div @click="goOrder(1)" class="grid-content bg-purple">
                  <div class="parcel_type">
                    <img
                      class="parcel_type_img"
                      src="@/assets/img/img3.png"
                      alt=""
                    />
                    <div>
                      <div class="text_l">未匹配包裹</div>
                      <div class="text_b">
                        {{
                          orderNumbers.unmatchedCount
                            ? orderNumbers.unmatchedCount
                            : 0
                        }}
                      </div>
                    </div>
                  </div>
                </div></el-col
              >

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6"
                ><div @click="goOrder(2)" class="grid-content bg-purple">
                  <div class="parcel_type">
                    <img
                      class="parcel_type_img"
                      src="@/assets/img/img4.png"
                      alt=""
                    />
                    <div>
                      <div class="text_l">待发货包裹</div>
                      <div class="text_b">
                        {{
                          orderNumbers.beDeliveredCount
                            ? orderNumbers.beDeliveredCount
                            : 0
                        }}
                      </div>
                    </div>
                  </div>
                </div></el-col
              >
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6"
                ><div @click="goOrder(3)" class="grid-content bg-purple">
                  <div class="parcel_type">
                    <img
                      class="parcel_type_img"
                      src="@/assets/img/img5.png"
                      alt=""
                    />
                    <div>
                      <div class="text_l">待确认包裹</div>
                      <div class="text_b">
                        {{
                          orderNumbers.confirmedCount
                            ? orderNumbers.confirmedCount
                            : 0
                        }}
                      </div>
                    </div>
                  </div>
                </div></el-col
              >
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6"
                ><div @click="goOrder(4)" class="grid-content bg-purple">
                  <div class="parcel_type">
                    <img
                      class="parcel_type_img"
                      src="@/assets/img/img6.png"
                      alt=""
                    />
                    <div>
                      <div class="text_l">待取货包裹</div>
                      <div class="text_b">
                        {{
                          orderNumbers.pickedUpCount
                            ? orderNumbers.pickedUpCount
                            : 0
                        }}
                      </div>
                    </div>
                  </div>
                </div></el-col
              >
            </el-row>
          </div>
          <div class="content_box">
            <div class="content_box_title">
              <div class="circle_l"></div>
              <div class="circle_r"></div>
              <div class="text_xl">运输中</div>
            </div>
            <div
              class="step_box"
              v-for="(item, index) in logisticsData"
              :key="index"
            >
              <div class="step_box_right">
                <div class="step_box_title">
                  <div>批次号：{{ item.name }}</div>
                  <div
                    v-if="
                      item.deliverprogressDtos != '' && item.deliverprogressDtos
                    "
                  >
                    {{
                      item.deliverprogressDtos[
                        item.deliverprogressDtos.length - 1
                      ].description
                    }}
                  </div>
                </div>
                <el-steps :active="item.stage" align-center>
                  <el-step title="集货中"></el-step>
                  <el-step title="装车发货"></el-step>
                  <el-step title="已起航"></el-step>
                  <el-step title="清关中"></el-step>
                  <el-step title="分拣中"></el-step>
                  <el-step title="等待取货"></el-step>
                  <el-step title="等完成"></el-step>
                </el-steps>
              </div>

              <el-divider direction="vertical"></el-divider>
              <i
                class="el-icon-arrow-right"
                @click="details(item.id, item.name, item)"
              ></i>
            </div>
          </div></div
      ></el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8"
        ><div class="grid-content bg-purple-light">
          <div class="user_info_box">
            <div class="user_img_box">
              <img class="user_img_bj" src="@/assets/img/img7.png" alt="" />
              <img
                class="user_img"
                :src="userInfo.avatar ? userInfo.avatar : userimg"
                alt=""
              />
            </div>
            <div class="user_name">{{ logistics_user.orderstartnumber }}</div>
            <div class="balance_box">
              <div class="balance_titile">账户余额</div>
              <div class="balance_num">${{ userInfo.balance }}</div>
              <div class="balance_btn">
                <div class="balance_titile" @click="topUp">账户充值</div>
                <div class="balance_titile" @click="toNoPay">未付款({{ userInfo.unpaid }})</div>
                <div class="balance_titile" @click="toBill">账单明细</div>
              </div>
            </div>
          </div>
          <div class="content_boxs" v-if="orderData.content != ''">
            <div class="content_box_title">
              <div class="circle_l"></div>
              <div class="circle_r"></div>
              <div class="text_xl">集货中</div>
            </div>
            <div>
              <el-row :gutter="10">
                <el-col
                  v-for="(item, index) in orderData.content"
                  :key="index"
                  :xs="24"
                  :sm="24"
                  :md="12"
                  :lg="24"
                  :xl="12"
                  ><div class="grid-content bg-purple">
                    <div class="right_box_l">
                      <div class="text_ko">批次号：{{ item.name }}</div>
                      <!-- :color="
                          item.deliverprogressDtos.length * 20 == 100
                            ? '#87A2FF'
                            : item.deliverprogressDtos.length * 20 == 80
                            ? '#FF9253'
                            : '#F3F3F3'
                        " -->
                      <el-progress
                        :stroke-width="15"
                        stroke-linecap="butt"
                        type="circle"
                        class="circle_boxs"
                        :percentage="
                          item.totalWeightKg > item.targetweightkg
                            ? 100
                            : item.totalWeightKg / item.targetweightkg
                            ? (
                                item.totalWeightKg / item.targetweightkg
                              ).toFixed(2) * 100
                            : 0
                        "
                      ></el-progress>
                      <div
                        class="text_ko text_wight"
                        v-if="
                          item.deliverprogressDtos &&
                          item.deliverprogressDtos != ''
                        "
                      >
                        {{
                          item.deliverprogressDtos[
                            item.deliverprogressDtos.length - 1
                          ].name
                        }}
                      </div>
                      <!-- <div class="text_ko text_wight">800/15000</div> -->
                      <img
                        @click="details(item.id, item.name, item)"
                        class="arrows_img"
                        src="@/assets/img/img2.png"
                        alt=""
                      />
                    </div></div
                ></el-col>
              </el-row>
            </div>
          </div></div
      ></el-col>
    </el-row>
    <!-- <el-dialog title="登录" :visible.sync="dialogTableVisible">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
           <el-form-item label="账号" prop="username">
              <el-input
                type="text"
                v-model="ruleForm.username"
             
              ></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                type="password"
                v-model="ruleForm.password"
           
              ></el-input>
            </el-form-item>
          
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')"
                >提交</el-button
              >
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog> -->
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
import { GoodsList } from "@/api/basisMG";
import Cookies from "js-cookie";
import Config from "@/settings";
import userimg from "@/assets/img/user.png";
export default {
  data() {
    return {
      userimg,
      url: [],
      orderNumbers: "",
      orderData: [],
      logisticsData: [],
      screen: {
        page: 1,
        size: 50,
        routetype: 1,
        aeronumber: "",
        name: "",
      },
      dialogTableVisible: true,
      logistics_user: "",
      userInfo: "",
    };
  },
  created() {

    this.getBatchsAndExpress();
    this.orderNumber();
    this.user();
    this.systemPhoto();
        this.orderList();
  },
  methods: {
    //去未付款
    toNoPay(){
this.$router.push({
  path:'/parcel/nonPayment'
})
    },
    topUp() {
      this.$router.push({
        path: "/userInfo/recharge",
      });
    },
    toBill() {
      this.$router.push({
        path: "/userInfo/bill",
      });
    },
    systemPhoto() {
      this.url = [];
      var data = {
        page: 1,
        size: 50,
      };
      crudDept.systemPhoto(data).then((res) => {
        this.url = res.content;
        this.$forceUpdate();
      });
    },
    user() {
      var logistics_user = JSON.parse(Cookies.get("logistics_user"));
      var data = {
        id: logistics_user.id,
      };
      crudDept.getUser(data).then((res) => {
        this.userInfo = res;
      });
    },
    orderNumber() {
      var data = {};
      crudDept.orderNumber(data).then((res) => {
        this.orderNumbers = res;
      });
    },
    goOrder(e) {
      if (e == 1) {
        this.$router.push({
          path: "/undetermined/unmatch",
        });
      } else if (e == 2) {
        this.$router.push({
          path: "/undetermined/unShipments",
        });
      } else if (e == 3) {
        this.$router.push({
          path: "/undetermined/undetermined",
        });
      } else if (e == 4) {
        this.$router.push({
          path: "/extractGoods/extractGoods",
        });
      }
    },
    //查询批次详情
    details(e, title, item) {
      localStorage.setItem("batch", JSON.stringify(item));
      this.$router.push({
        path:
          "/extractGoods/details?id=" +
          e +
          "&name=进度查询" +
          "&title=" +
          title,
      });
    },
    //批次物流
    getBatchsAndExpress() {
            var logistics_user = JSON.parse(Cookies.get("logistics_user"));
      var data = {
        page: 1,
        size: 100,
        routetype: 1,
        grouptype: 40,
        stages: "2,3,4,5,6",
             createdbyid:logistics_user.id
        // type: 101,
      };
      crudDept.getBatchsAndExpress(data).then((res) => {
        this.logisticsData = res.content;
        //console.log(this.logisticsData);
      });
    },
    //批次集货中
    orderList() {

      var data = {
        page: 1,
        size: 100,
        routetype: 1,
        grouptype: 40,
        stage: 1,
   
        // grouptype:40,
      };
      crudDept.getBatchsAndExpress(data).then((res) => {
        this.orderData = res;
      });
    },
    toDetails() {},
  },
};
</script>
<style scoped>
.arrows_img {
  display: block;
  margin: 0 auto;
}
.content_box {
  border-radius: 10px;
}
.el-divider--vertical {
  height: 4em;
}
.el-icon-arrow-right {
  margin-right: 34px;
}
.content_box_title {
  margin-bottom: 16px;
}
.content_boxs {
  background: #ffffff;
  opacity: 1;
  border-radius: 20px;
  padding: 37px 30px 30px;
  box-sizing: border-box;
  margin-top: 18px;
}
.swiper {
  margin-bottom: 14px;
}
.swiper >>> .el-carousel__item {
  /* background: #fff; */
}
.swiper_img {
  width: 100%;

  height: 278px;
  object-fit: cover;
}
.parcel_type {
  width: 100%;
  height: 138px;
  background: #ffffff;
  opacity: 1;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 30px;
  box-sizing: border-box;
  margin-bottom: 19px;
  /* justify-content: center; */
}
.parcel_type:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.parcel_type_img {
  width: 78px;
  height: 78px;
  margin-right: 30px;
}
.text_l {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #333333;
}
.text_b {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 42px;
  color: #333333;
}
.user_info_box {
  width: 100%;
  height: 420px;
  background: #ffffff;
  border-radius: 20px;
  text-align: center;
  padding: 30px 0 57px;
  box-sizing: border-box;
  margin-top: 10px;
}
.user_img_box {
  position: relative;
}
.user_img_bj {
  z-index: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.user_img {
  width: 107px;
  height: 107px;
  background: rgba(0, 0, 0, 0);
  opacity: 1;
  border-radius: 50%;
  z-index: 1;
  margin-right: 13px;
  margin-top: 11px;
}
.user_name {
  font-size: 16px;
  font-family: PingFang SC;
  line-height: 22px;
  color: #333333;
  margin-top: 40px;
}
.balance_box {
  width: 70%;
  height: auto;
  background: linear-gradient(47deg, #5178ff 0%, #a4aaff 100%);
  opacity: 1;
  border-radius: 20px;
  margin: 14px auto 0;
  text-align: center;
  padding: 20px 50px 30px;
  box-sizing: border-box;
}
.balance_titile {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 18px;
  color: #ffffff;
  cursor: pointer;
}
.balance_num {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 42px;
  margin-top: 10px;
  color: #ffffff;
}
.balance_btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
}
.right_box_l {
  width: 100%;
  height: auto;
  box-shadow: 0px 0px 6px rgba(3, 55, 159, 0.16);
  opacity: 1;
  border-radius: 20px;
  padding: 30px;
  box-sizing: border-box;
  text-align: center;
  margin-bottom: 20px;
}
.right_box_l:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.text_ko {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 21px;
  color: #333333;
  margin-bottom: 7px;
}
.circle_boxs {
  margin: 18px auto;
}
.text_wight {
  font-weight: normal !important;
}
.step_box_right {
  width: 90%;
}
.step_box_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #5178ff;
  opacity: 1;
  padding-left: 34px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin-bottom: 17px;
}
.step_box >>> .el-step.is-horizontal .el-step__line {
  height: 6px !important;
  background-color: #fff !important;
  border-color: #a5b8fc !important;
  border: 1px solid #a5b8fc !important;
  top: 7px;
}
.step_box >>> .el-step__head.is-wait {
  color: #a5b8fc;
}
.step_box >>> .el-step__line-inner {
  border: none !important;
  border-style: solid !important;
}
.step_box >>> .el-step__head.is-process {
  color: #a5b8fc;
  border-color: #a5b8fc;
}
.step_box >>> .el-step__title.is-wait {
  color: #a5b8fc;
}
.step_box >>> .el-step__title.is-process {
  color: #a5b8fc;
}
.step_box >>> .el-step__head.is-finish {
  color: #85a0ff !important;
  border-color: #85a0ff !important;
}
.step_box >>> .el-step__title.is-finish {
  color: #85a0ff !important;
}
.el-step.is-horizontal .el-step__line {
}
.step_box >>> .el-step__icon.is-text {
  border: 4px solid !important;
}
.step_box >>> .el-step__icon-inner {
  color: #fff !important;
}
.content_box_title {
  margin-bottom: 32px;
}
.step_box {
  margin-bottom: 21px;
  height: 118px;
  background: #f5f7ff;
  opacity: 1;
  padding: 22px 0;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.step_box:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue